import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { GrFormClose } from "react-icons/gr";
import { send_mail } from "../../api/mail";
import { resetPassword, forgotPasswordPhone } from "../../api/auth";
import useFirebase from "../../hooks/useFirebase";

const ForgotPasswordModal = ({ isOpen, onClose, onSendButtonClick }) => {
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [usePhoneNumber, setUsePhoneNumber] = useState(false);
  const [sendOTPCode, setSendOTPCode] = useState(false);
  const [changePassword, setChangePassword] = useState(false);

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [apiOtp, setApiOtp] = useState("");
  const [disableApiOtp, setDisableApiOtp] = useState(false);

  const [otpValues, setOtpValues] = useState(["", "", "", ""]);

  const [countdown, setCountdown] = useState(5);
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  // handle by firebase(reset password)
  const [handledByFirebase, setHandledByFirebase] = useState(false);
  const [firebaseMessage, setFirebaseMessage] = useState('');

  const [error, setError] = useState("");

  const { forgotPasswordFirebase } = useFirebase();

  const searchCountryCode = (option, inputValue) => {
    return option.data.code.includes(inputValue);
  };

  const handleSubmitAndSaveEmail = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    /*************************************************/
    // handle by firebase
    const res = await forgotPasswordFirebase(email)
    console.log({res})
    if (!res.status) {
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.reason,
      });
      return false;
    }
    setIsLoading(false);
    // setApiOtp(null); // pass null to trigger useEffect
    setHandledByFirebase(true);
    setFirebaseMessage(res.message ?? `Password reset link has been sent to ${email}`);
    /*************************************************/
    // handle by website
    // send email
    // const mailObj = {
    //   to: email,
    //   recipient: email,
    //   subject: "Forgot Password",
    //   body: "",
    // };
    // const res = await send_mail(mailObj, "forgot_password");
    // if (!res.status) {
    //   setIsLoading(false);
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: res.reason,
    //   });
    //   return false;
    // }
    // setUsePhoneNumber(false);
    // setSendOTPCode(true);
    // setShowResendOtp(true);
    // setDisableApiOtp(true);
    // setCountdown(5);
    // setApiOtp(res.data.code);
    // setIsLoading(false);
    /*************************************************/
    // // onSendButtonClick();
  };

  const handleSubmitAndSavePhone = (e) => {
    e.preventDefault();
    setPhoneNumber("");
    setPhoneCode("");

    onSendButtonClick();
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    validatePassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handlePhoneCodeChange = (e) => {
    setPhoneCode(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleEmailClick = () => {
    setUsePhoneNumber(false);
  };

  const handlePhoneNumberClick = () => {
    setUsePhoneNumber(true);
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-zA-Z])(?=.*\d).{8,20}$/;

    if (!regex.test(password)) {
      setError(
        "Password should be between 8 to 20 characters and contain at least one alphabet and one numeric character."
      );
      return false;
    } else {
      setError("");
      return true;
    }
  };

  const updatePassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // check password
    if (confirmPassword !== password) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Password Mismatch",
      });
      setIsLoading(false);
      return false;
    }
    if(!validatePassword(password)){
      setIsLoading(false);
      return false;
    }
    try {
      // continue
      const postData = {
        email: email,
        code: apiOtp,
        password: password,
      };
      // update password via email
      const res = await resetPassword(postData);
      if (res.status) {
        onSendButtonClick();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res?.reason ?? res?.message,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (apiOtp) {
      setShowResendOtp(true);
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [apiOtp]);

  const handleSendCodeClick = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const formData = {
        phone: phoneNumber,
      };
      const response = await forgotPasswordPhone(formData);
      if (response.status == false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      } else {
        setUsePhoneNumber(false);
        setEmail(response.data.email);
        setSendOTPCode(true);
        setShowResendOtp(true);
        setDisableApiOtp(true);
        setCountdown(5);
        setApiOtp(response.data.code);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // here might be phone or email
  const handlereSendCodeClick = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    try {
      let response;
      if (phoneNumber) {
        const formData = {
          phone: phoneNumber,
        };
        response = await forgotPasswordPhone(formData);
      } else {
        const mailObj = {
          to: email,
          recipient: email,
          subject: "Forgot Password",
          body: "",
        };
        response = await send_mail(mailObj, "forgot_password");
      }
      if (response.status == false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      } else {
        setEmail(response.data.email);
        setShowResendOtp(true);
        setDisableApiOtp(true);
        setCountdown(5);
        setApiOtp(response.data.code);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const handleOTPChange = (index) => (e) => {
    const { value } = e.target;
    setOtp(otp.map((digit, i) => (i === index ? value : digit)));
    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);

    if (index < 3 && value) {
      if (inputRefs[index + 1] && inputRefs[index + 1].current) {
        inputRefs[index + 1].current.focus();
      }
    }

    if (index === 3 && newOtpValues[3] !== "") {
      const otp_input = newOtpValues.join("");
      if (otp_input == apiOtp) {
        // let them change password
        setSendOTPCode(false);
        setChangePassword(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "OTP",
          text: "OTP does not match!",
        });
      }
    }
  };

  //useEffect(() => {
  //  // This code will run whenever otpValues changes
  //  console.log("Latest otpValues:", otpValues);
  //}, [otpValues]);

  const handleTesting = (e) => {
    e.preventDefault();
    setOtp(["", "", "", ""]);
    onSendButtonClick();
  };

  useEffect(() => {
    fetch("https://restcountries.com/v2/all")
      .then((response) => response.json())
      .then((data) => {
        const countries = data.map((country) => ({
          image: country.flags.svg,
          code: country.callingCodes[0],
        }));

        setCountries(countries);
        const defaultCountry = countries.find(
          (country) => country.code === "60"
        );
        if (defaultCountry) {
          setSelectedCountry(defaultCountry);
        }
      })
      .catch((error) => console.error("Error:", error));
  }, []);

  const getCompleteOtp = () => {
    return otp.join("");
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="forgot_password_modal">
      <div
        className="container"
        style={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: "93%",
            top: "5%",
          }}
        >
          <GrFormClose
            onClick={onClose}
            style={{ fontSize: "20px", cursor: "pointer" }}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <img
            src="/img/homepage/password-recovery-thumbnail.png"
            alt=""
            style={{ width: "200px", height: "200px" }}
          />
          <h3>Password Recovery</h3>
        </div>
        <form style={{ width: "-webkit-fill-available" }}>
          {usePhoneNumber ? (
            <>
              <div className="form_phoneNumber">
                <label
                  htmlFor="phoneNumber"
                  style={{
                    fontSize: "12px",
                    color: "black",
                    fontWeight: "500",
                  }}
                >
                  Phone Number
                </label>
                <div style={{ display: "flex" }}>
                  <Select
                    value={selectedCountry}
                    options={countries}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: "90px",
                        border: "none",
                      }),
                      option: (provided) => ({
                        ...provided,
                        color: "black",
                        backgroundColor: "white",
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        padding: "0",
                      }),
                    }}
                    formatOptionLabel={(country) => (
                      <div className="country-option">
                        <img
                          src={country.image}
                          alt="country-image"
                          style={{
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                          }}
                        />
                        <span style={{ color: "#000" }}>+{country.code}</span>
                      </div>
                    )}
                    onChange={(selectedOption) =>
                      handleCountryChange(selectedOption)
                    }
                    isSearchable={true}
                    filterOption={searchCountryCode}
                  />
                  <input
                    type="text"
                    name="phoneNumber"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    required
                    placeholder="Type your phone number"
                    style={{ border: "0", width: "90%" }}
                  />
                </div>
              </div>
              {isLoading ? (
                <button id="send_btn" disabled>
                  Loading...
                </button>
              ) : (
                <button id="send_btn" onClick={handleSendCodeClick}>
                  Send Code
                </button>
              )}
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p
                  style={{
                    fontSize: "12px",
                    color: "black",
                    fontWeight: "500",
                    marginRight: "10px",
                  }}
                >
                  Try Other Way?
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#967F65",
                    fontWeight: "700",
                    cursor: "pointer",
                  }}
                  onClick={handleEmailClick}
                >
                  Use Email
                </p>
              </div>
            </>
          ) : sendOTPCode ? (
            <>
              <div className="otp_number">
                <label htmlFor="otp">
                  {[0, 1, 2, 3].map((index) => (
                    <input
                      id="otp"
                      ref={inputRefs[index]}
                      key={index}
                      type="text"
                      name="otp"
                      maxLength={1}
                      value={otp[index]}
                      onChange={handleOTPChange(index)}
                    />
                  ))}
                </label>
              </div>
              <div className="phone_number_code">
                {/* {apiOtp ? (
                  <div className="text-center" style={{ color: "#000" }}>
                    OTP: {apiOtp}
                  </div>
                ) : (
                  <></>
                )} */}
                {showResendOtp && countdown > 0 ? (
                  <div>
                    <p>Resend after {countdown} seconds</p>
                  </div>
                ) : (
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "black",
                      }}
                    >
                      Haven't received code?
                    </span>
                    {isLoading ? (
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          marginLeft: "5px",
                          cursor: "pointer",
                        }}
                      >
                        Loading...
                      </span>
                    ) : (
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          marginLeft: "5px",
                          cursor: "pointer",
                        }}
                        onClick={handlereSendCodeClick}
                      >
                        Resend.
                      </span>
                    )}
                  </div>
                )}
              </div>
            </>
          ) : changePassword ? (
            <>
              <div className="form_email tooltip-container">
                {error && (
                  <div className="custom-tooltip">
                    <div className="tooltip-arrow"></div>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "13px",
                        color: "red",
                      }}
                    >
                      <div className="error">{error}</div>
                    </p>
                  </div>
                )}
                <label
                  htmlFor="password"
                  style={{
                    fontSize: "12px",
                    color: "black",
                    fontWeight: "500",
                  }}
                >
                  New Password
                </label>
                <input
                  type="password"
                  name="password"
                  value={password}
                  onChange={handlePasswordChange}
                  required
                  placeholder="Enter your new password."
                  style={{ border: "0" }}
                />
              </div>
              <div className="form_email" style={{ marginTop: "1.5em" }}>
                <label
                  htmlFor="password"
                  style={{
                    fontSize: "12px",
                    color: "black",
                    fontWeight: "500",
                  }}
                >
                  Confirm Password
                </label>
                <input
                  type="password"
                  name="confirm_password"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  required
                  placeholder="Confirm your new password."
                  style={{ border: "0" }}
                />
              </div>
              {isLoading ? (
                <button id="send_btn" disabled>
                  Loading...
                </button>
              ) : (
                <button id="send_btn" onClick={updatePassword}>
                  Update
                </button>
              )}
            </>
          ) : handledByFirebase ? (
            <>
              <div className="form_email tooltip-container">
                <p style={{fontSize: "15px", color: "black", fontWeight: "500", textAlign: "center"}}>
                  {firebaseMessage}
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="form_email">
                <label
                  htmlFor="email"
                  style={{
                    fontSize: "12px",
                    color: "black",
                    fontWeight: "500",
                  }}
                >
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={handleEmailChange}
                  required
                  placeholder="Type your email address"
                  style={{ border: "0" }}
                />
              </div>
              {isLoading ? (
                <button id="send_btn" disabled>
                  Loading...
                </button>
              ) : (
                <button id="send_btn" onClick={handleSubmitAndSaveEmail}>
                  Send Code
                </button>
              )}
              <div style={{ display: "none", justifyContent: "center" }}>
                {/* <div style={{ display: "flex", justifyContent: "center" }}> */}
                <p
                  style={{
                    fontSize: "12px",
                    color: "black",
                    fontWeight: "500",
                    marginRight: "10px",
                  }}
                >
                  Try Other Way?
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#967F65",
                    fontWeight: "700",
                    cursor: "pointer",
                  }}
                  onClick={handlePhoneNumberClick}
                >
                  Use phone number
                </p>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
